import { makeStyles } from "@material-ui/core/styles";

export const useSubscriptionStyles = makeStyles((theme) => ({
  section: {
    padding: "16px",
    paddingTop: "8px",
    paddingLeft: "0",
    paddingRight: "16px",
    // maxHeight: "calc(100vh - 140px)",
    overflowY: "auto",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
      backgroundColor: "#1a1a1a",
      paddingBottom: "86px",
      height: "calc(100vh - 80px)",
      paddingRight: "15px",
    },
  },
  sectionTitle: {
    color: "#f06ec4",
    fontWeight: 600,
    fontSize: "24.5px",
    marginBottom: "3px",
  },
  infoText: {
    color: "white",
    fontSize: "11px",
    marginBottom: "30px",
  },
  tierCard: {
    backgroundColor: "#1E1E1E",
    borderRadius: "8px",
    marginBottom: "16px",
    border: "1px solid #363636",
  },
  cardContent: {
    height: "220px",
    padding: "10px !important",
  },
  tierHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  tierName: {
    color: "#f06ec4",
    fontSize: "18px",
    fontWeight: 600,
  },
  formRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
    gap: "16px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
      width: "100%",
    },
  },
  label: {
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    minWidth: "120px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      fontSize: "16px",
      marginBottom: "4px",
    },
  },
  inputField: {
    //  border: "1px solid #363636",
    flex: 1,
    "& .MuiInputBase-root": { color: "white" },
    "& .MuiOutlinedInput-root": {
      //  "& fieldset": { borderColor: "#EDECED" },
      "&:hover fieldset": { borderColor: "#f06ec4" },
      "&.Mui-focused fieldset": { borderColor: "#f06ec4" },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
    },
  },
  saveButton: {
    backgroundColor: "#f06ec4",
    color: "white",
    float: "right",
    marginTop: "20px",
    "&:hover": { backgroundColor: "#d45ca5" },
    [theme.breakpoints.down("sm")]: {
      float: "none",
      width: "100%",
      marginTop: "16px",
    },
  },
}));
